import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {
  private overlayVisible = new BehaviorSubject<boolean>(true);

  // Observable for other components to subscribe to
  overlayVisible$ = this.overlayVisible.asObservable();

  // Method to change the overlay visibility state
  setOverlayVisible(isVisible: boolean): void {
    this.overlayVisible.next(isVisible);
  }

}
